/**
 * Route references for the tenant-management plugin.
 *
 * This module defines route references that are used across the plugin.
 * Keeping them in a separate file prevents circular dependencies between
 * component modules and the plugin entry points (alpha.tsx, index.ts).
 *
 * @packageDocumentation
 */

import { createRouteRef } from '@backstage/frontend-plugin-api';

/**
 * Route reference for the tenant management list page.
 * @public
 */
export const rootRouteRef = createRouteRef();

/**
 * Route reference for individual tenant details page.
 * @public
 */
export const tenantDetailsRouteRef = createRouteRef({
  params: ['tenantId'],
});

/**
 * Route reference for release rollout operations.
 * @public
 */
export const upgradesRouteRef = createRouteRef();
